import { useOrganization } from '@/hooks/use-organization';
import { useCustomerPermissions } from '@/hooks/useCustomerPermissions';

/**
 * Beneficiary section/action permissions resolved against the ACTIVE
 * organization (the one selected in the dashboard switcher). Every customer
 * gate (dashboard, navigation, protected routes, support groups) must use this
 * so they all agree, matching mobile's PermissionsContext (activeOrgId).
 *
 * Resolution waits for the active organization to load, so a gate never
 * briefly applies the org-agnostic "newest override across all orgs" result.
 */
export function useActiveCustomerPermissions() {
  const { selectedOrganization, loading: organizationLoading } = useOrganization();
  const permissions = useCustomerPermissions(selectedOrganization?.id, {
    enabled: !organizationLoading,
  });
  return {
    ...permissions,
    organizationId: selectedOrganization?.id,
    loading: organizationLoading || permissions.loading,
  };
}
